import MedicalCertificates from "@/views/patient/medical_certificates.vue";
import Exams from "@/views/patient/exams.vue";
import Prescriptions from "@/views/patient/prescriptions.vue";
import GlassesPrescriptions from "@/views/patient/glasses_prescriptions.vue";

export default [
  {
    path: "atestados",
    component: MedicalCertificates,
    meta: { patientRoute: true },
  },
  {
    path: "exames",
    component: Exams,
    meta: { patientRoute: true },
  },
  {
    path: "receitas",
    component: Prescriptions,
    meta: { patientRoute: true },
  },
  {
    path: "receitas-oculos",
    component: GlassesPrescriptions,
    meta: { patientRoute: true },
  },
];
